<template>
    <div class="row">
        <div class="col-6">
            <div class="form-group">
                <label for="fecha_sesion">Fecha inicio de la sesión</label>
                <ValidationProvider name="fecha_sesion" rules="required" v-slot="{ errors }" id="fecha_sesion">
                    <datetime
                        v-model="sesion.fecha_zulu"
                        :input-class="'form-control ' + (errors[0] ? 'is-invalid' : '')"
                        type="datetime"
                        input-id="fecha_zulu"
                        :value-zone="configuracion.TIMEZONE"
                    ></datetime>
                    <span v-if="errors[0]" id="exampleInputEmail1-error" class="error invalid-feedback" style="display: block">{{ errors[0] }}</span>
                </ValidationProvider>
            </div>
        </div>
        <div class="col-6">
            <div class="form-group">
                <label for="end_session_date">Fecha fin de la sesión</label>
                <ValidationProvider name="end_session_date" rules="required" v-slot="{ errors }" id="end_session_date">
                    <datetime
                        :min-datetime="sesion.fecha_zulu"
                        v-model="sesion.end_session_date"
                        :input-class="'form-control ' + (errors[0] ? 'is-invalid' : '')"
                        type="datetime"
                        input-id="end_session_date"
                        :value-zone="configuracion.TIMEZONE"
                    ></datetime>
                    <span v-if="errors[0]" class="error invalid-feedback" style="display: block">{{ errors[0] }}</span>
                </ValidationProvider>
            </div>
        </div>
        <div class="col-12" v-if="manager.tipo == 1">
            <div class="form-group">
                <div class="custom-control custom-checkbox">
                    <input class="custom-control-input" type="checkbox" id="customCheckbox2" v-model="sesion.fecha_provisional">
                    <label for="customCheckbox2" class="custom-control-label">Fecha y hora provisional</label>
                </div>
            </div>
        </div>
        <div class="col-12">
            <div class="form-group">
                <label for="texto">Texto identificativo de la sesión:</label>
                <input type="text" class="form-control" id="texto" placeholder="Texto" v-model="sesion.text">
            </div>
        </div>
        <div class="col-12">
            <div class="form-group">
                <label for="texto">Apertura de puertas:</label>
                <input type="text" class="form-control" id="apertura" placeholder="Texto" v-model="sesion.apertura_puertas">
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        props: ['sesion'],
        data() {
            return {
            }
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            },
            manager() {
                return this.$store.getters.getFooter;
            }
        },
    }
</script>
